<template>
  <div class="whitesmoke black--text ml-3" id="requestor-container">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <div
      id="daddy"
      v-if="
        Object.keys(form_request).length != 0 &&
        form_request != undefined &&
        form_request != null
      "
    >
      <v-card
        elevation="3"
        class="pa-3 ml-2 mr-2 mb-3 whitesmoke"
        style="width: 100%"
      >
        <!-- row -->
        <div
          id="case_data"
          class="d-flex flex-row justify-start align-center flex-wrap mt-4"
        >
          <div class="label-pairs">
            <label>Firearm Description:</label>
            <article>{{ form_request.description }}</article>
          </div>

          <div class="label-pairs">
            <label>Mailing Address:</label>
            <article>{{ form_request.st_address.toUpperCase() }},</article>
            <article>
              {{ form_request.city.toUpperCase() }},
              {{ form_request.state.toUpperCase() }}
              {{ form_request.zip }}
            </article>
          </div>
        </div>
        <h4 class="mt-3">Citizen Uploads</h4>
        <div
          class="file-item ml-2"
          v-for="doc_file in req_file_docs"
          :key="doc_file.req_file_docsId"
        >
          <div class="img-item-wrp">
            <!--<img :src="'./upload/userdocs/' + doc_file.filename" :alt="doc_file.filetitle" />-->
            <div>
              <a
                :href="rpd_userdoc_server + doc_file.filename"
                target="_blank"
                >{{ doc_file.filetitle }}</a
              >
            </div>
          </div>
        </div>
        <div
          class="file-item ml-2"
          v-for="doc_file in req_file_pers"
          :key="doc_file.req_file_persId"
        >
          <div class="img-item-wrp">
            <!--<img :src="'./upload/userdocs/' + doc_file.filename" :alt="doc_file.filetitle" />-->
            <div>
              <a :href="perimg_server + doc_file.filename" target="_blank">{{
                doc_file.filetitle
              }}</a>
            </div>
          </div>
        </div>

        <div
          class="file-item ml-2"
          v-for="doc_file in req_file_rpd_docs"
          :key="doc_file.req_file_rpd_docsId"
        >
          <div class="img-item-wrp">
            <!--<img :src="'./upload/userdocs/' + doc_file.filename" :alt="doc_file.filetitle" />-->
            <div>
              <a
                :href="rpd_docimg_server + doc_file.filename"
                target="_blank"
                >{{ doc_file.filetitle }}</a
              >
            </div>
          </div>
          <div class="questions d-flex flex-column justify-center">
            <v-expansion-panels class="mt-3 ml-3 mr-3">
              <v-expansion-panel>
                <v-expansion-panel-header
                  >Background Questions</v-expansion-panel-header
                >
                <v-expansion-panel-content class="whitesmoke">
                  <div
                    class="question"
                    v-for="q in questions.lst_vm_Question"
                    :key="q.label"
                  >
                    <div class="question mb-3">
                      {{ q.label }} {{ q.question }}
                    </div>
                    <div class="answer">Answer: {{ q.answer }}</div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </v-card>
    </div>
    <div
      id="sonny"
      v-if="
        Object.keys(form_request).length === 0 ||
        form_request == undefined ||
        form_request == null
      "
    >
      <h4>A request has not been loaded.</h4>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/*barb css*/

.questions {
  width: 98%;
}
.question {
  font-style: italic;
  font-size: 1rem;
}
.answer {
  font-style: normal;
  font-size: 1rem;
  font-weight: 600;
}
#requestor-container {
  width: 100%;
}
.label-pairs {
  display: flex; /* or inline-flex */
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: baseline;
  margin-left: 12px;
}
.label-pairs label {
  font-weight: 600;
}
.label-pairs article {
  font-size: 1.1rem;
  padding-left: 3px;
}
.xfiles {
  outline: 1px solid grey;
  padding: 0 5px 0 5px;
  color: orangered;
  cursor: pointer;
  margin-right: 2px;
}

.img-item-wrp {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: row;
  flex-direction: row;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
}

.img-item-wrp img {
  display: inline-block;
  width: 40px;
  height: auto;
}

.img-lst-wrp-flex {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: row;
  flex-direction: row;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  -webkit-align-items: center;
  align-items: center;
  flex-wrap: wrap;
  min-height: 40px;
  background-color: whitesmoke;
  border: solid 1px black;
  width: 93%;
  margin: auto;
}
.img-lst-wrp-flex .file-item {
  padding: 2px;
  border: solid 1px black;
  margin: 10px;
  font-weight: 600;
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "requestor",
  mixins: [bus_common],
  props: [
    "form_request",
    "req_file_docs",
    "req_file_pers",
    "req_file_rpd_docs",
    "questions",
  ],
  data() {
    return {
      perimg_server: "https://firearmreq.renopdportal.org/upload/pers/",
      rpd_docimg_server: "https://firearmreq.renopdportal.org/upload/rpddocs/",
      rpd_userdoc_server:
        "https://firearmreq.renopdportal.org/upload/userdocs/",
    };
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    init() {},
  },

  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
